import { Check } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";

const plans = [
  {
    name: "Free",
    price: "0",
    description: "Para corredores que están empezando.",
    features: [
      "CRM Básico (hasta 10 propiedades)",
      "Publicación en portales base",
      "Soporte vía email",
      "Valorización básica"
    ]
  },
  {
    name: "Professional",
    price: "49.990",
    description: "Nuestra opción más popular para independientes.",
    features: [
      "CRM Ilimitado",
      "Tasaciones IA Ilimitadas",
      "Mapa Inmobiliario Completo",
      "Descarga de Informes CSV",
      "Soporte Legal y Contable",
      "Alertas de Mercado"
    ],
    featured: true
  },
  {
    name: "Enterprise",
    price: "Consultar",
    description: "Para oficinas de corretaje y grandes equipos.",
    features: [
      "Todo lo de Professional",
      "Múltiples usuarios",
      "API de Valorización",
      "Marca Blanca (Tu Logo)",
      "Gestión de equipo avanzada"
    ]
  }
];

export function PricingPlans() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
      {plans.map((plan, idx) => (
            <div 
              key={idx} 
              className={`brutalist-border p-12 flex flex-col ${plan.featured ? 'bg-ink text-parchment scale-105 z-10' : 'bg-parchment text-ink'}`}
            >
              <div className="mb-8">
                <h3 className="text-2xl font-display font-black uppercase italic mb-2">{plan.name}</h3>
                <div className="flex items-baseline gap-1 overflow-hidden">
                  <span className="text-sm font-black uppercase tracking-widest opacity-60">CLP</span>
                  <span className={cn(
                    "font-display font-black",
                    plan.price === "Consultar" ? "text-3xl" : "text-5xl"
                  )}>{plan.price}</span>
                  {plan.price !== "Consultar" && <span className="text-sm font-black opacity-60">/MES</span>}
                </div>
              </div>
              
              <p className="font-serif italic opacity-70 mb-12 min-h-[3rem]">
                {plan.description}
              </p>

              <ul className="space-y-6 mb-12 flex-1">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <Check className={`h-5 w-5 flex-shrink-0 ${plan.featured ? 'text-terracotta' : 'text-ink'}`} />
                    <span className="text-sm font-black uppercase tracking-widest">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button 
                variant={plan.featured ? "terracotta" : "default"} 
                size="lg" 
                className="w-full h-16"
              >
                {plan.price === "Consultar" ? "CONTACTAR VENTAS" : "EMPEZAR AHORA"}
              </Button>
            </div>
          ))}
    </div>
  );
}
